import styled from "styled-components";

export const CardContainer = styled.div`
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  background-color: #000;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const CardCover = styled.div`
  background: url(${({ imageUrl }) => imageUrl});
  background-size: cover;
  background-position: ${({ position }) =>
    position ? `${position.x}% ${position.y}%` : "center"};
  height: 170px;
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  position: relative;
`;

export const CardOverlay = styled.div`
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.2) 48.34%,
    #000 93.86%
  );
  position: absolute;
  inset: 0;
`;

export const CardContentContainer = styled.div`
  position: relative;
  padding: 12px 14px;
`;

export const CardHeading = styled.h1`
  margin: 0;
  font-size: 22px;
  color: white;
  max-width: 70%;
  font-weight: 500;
`;

export const CardArrowContainer = styled.div`
  position: absolute;
  bottom: 12px;
  right: 14px;
  opacity: 0.5;
`;
